import { Injectable, OnDestroy } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationStart, UrlTree } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { Breadcrumb } from './breadcrumb.model';

type SavedBreadcrumb = {
  breadcrumb: Breadcrumb,
  namespace: string
}

@Injectable()
export class BreadcrumbsService implements OnDestroy {

  private savedBreadcrumbs: SavedBreadcrumb[] = [];
  private routerSubscription: Subscription = null;
  private ignoredUrlParts: string[] = ['list'];
  private lastUrl: string = location.pathname + location.search;

  constructor(
    private router: Router
  ) {
    this.watchRouterChanged();
  }

  ngOnDestroy() {
    this.stopWatchingRouter();
  }

  public getExtraBreadcrumb(): Breadcrumb {
    const currentPath = location.pathname;

    for (const savedBreadcrumb of this.savedBreadcrumbs) {
      if (currentPath.indexOf(savedBreadcrumb.namespace) === 0) {
        return savedBreadcrumb.breadcrumb;
      }
    }

    return null;
  }

  private saveBreadcrumb(name: string, urlFrom: string, urlTo: string): void {
    const urlFromTree = this.router.parseUrl(urlFrom);

    this.savedBreadcrumbs.push({
      breadcrumb: new Breadcrumb(
          '',
          urlFrom.split('?').shift(),
          urlFromTree.queryParams,
          name
        ),
      namespace: this.normalizeUrl(urlTo)
    });
  }

  private normalizeUrl(url: string) {
    const urlParts = url.split('?').shift().split('/');

    while (
      urlParts.length > 0 &&
      this.ignoredUrlParts.indexOf(urlParts[urlParts.length - 1]) !== -1
    ) {
      urlParts.pop();
    }

    return urlParts.join('/');
  }

  private stopWatchingRouter() {
    this.routerSubscription.unsubscribe();
  }

  private watchRouterChanged() {
    this.routerSubscription = this.router.events
      .filter((event) => event instanceof NavigationStart)
      .map((navigation: NavigationStart) => navigation.url)
      .subscribe((urlTo) => {
        this.removeObsoleteBreadcrumbs();

        const urlToTree = this.router.parseUrl(urlTo);
        const urlFrom = this.lastUrl;

        this.lastUrl = urlTo;

        if (
          !urlToTree.queryParams.hasOwnProperty('extraBreadcrumb') ||
          urlFrom.split('?').shift() === urlTo.split('?').shift()
        ) {
          return;
        }

        this.saveBreadcrumb(urlToTree.queryParams['extraBreadcrumb'], urlFrom, urlTo);

        setTimeout(() => { this.cleanUrl(); });
      });
  }

  private cleanUrl() {
    const currentQueryParams = this.router.parseUrl(location.search).queryParams;
    delete currentQueryParams['extraBreadcrumb'];

    this.router.navigate(
      [location.pathname],
      { queryParams: currentQueryParams, replaceUrl: true }
    );
  }

  private removeObsoleteBreadcrumbs() {
    const currentPath = location.pathname;

    for (let i = 0; i < this.savedBreadcrumbs.length; i++) {
      if (currentPath.indexOf(this.savedBreadcrumbs[i].namespace) !== 0) {
        this.savedBreadcrumbs.splice(i, 1);
        i--;
      }
    }
  }

}



// WEBPACK FOOTER //
// /dist/src/app/ui/breadcrumbs/breadcrumbs.service.ts